export const contentful = {
  SPACE_ID: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  ACCESS_TOKEN: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
}